// extracted by mini-css-extract-plugin
module.exports = {"root":"ChartLegend_root__1XJzX","item":"ChartLegend_item__2SvG4","icon":"ChartLegend_icon__3RQ_6"};